import * as React from "react";
type Props = {
  className?: string,
};
function SvgCredit({ className }: Props) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Credit"
      className={className}
    >
      <path
        d="M7.49269 5.13055L3.68755 8.9454C3.26412 9.41512 2.86983 9.92083 2.51726 10.4688C2.36583 10.7305 2.21726 10.994 2.08869 11.2717C0.785263 14.258 0.830977 17.7145 2.21326 20.6597C3.74983 24.074 6.34298 26.8203 9.55612 28.4374C12.7201 30.1614 16.3458 30.67 19.8207 29.878C21.7115 29.4825 23.4321 28.5277 24.8041 27.1563L24.8241 27.1363L27.7881 24.1723M27.7881 24.1723C26.4161 25.5437 24.6955 26.4985 22.8047 26.8934C19.3298 27.686 15.7041 27.1774 12.5401 25.4528C9.32698 23.8363 6.73383 21.09 5.19726 17.6757C3.81498 14.73 3.76926 11.274 5.07269 8.28769C5.20126 8.00998 5.35041 7.74655 5.50126 7.48483C7.70641 4.0574 11.4087 2.09912 15.2904 2.29969C17.7533 2.31455 20.1801 2.92883 22.3858 4.09569C23.051 4.44769 23.6933 4.84655 24.3087 5.28998C24.3795 5.34026 24.4527 5.38826 24.523 5.43912C25.1218 5.87912 25.6933 6.36198 26.2321 6.88369L26.2995 6.94998C29.5584 9.88769 31.1818 14.3963 30.6041 18.9031C30.4504 19.7203 30.1984 20.5134 29.8544 21.262C29.3235 22.3545 28.6287 23.3277 27.8081 24.1523L27.7881 24.1723ZM16.8784 15.2688C19.3715 18.5985 21.0333 18.5985 22.6955 23.5934M18.0784 6.35112C19.2144 7.94826 19.7681 9.77283 19.6453 11.5163C19.3544 13.1334 18.3481 14.4763 16.847 15.2511C15.7915 13.7403 15.2687 12.026 15.3618 10.3803C15.607 8.68198 16.5795 7.23969 18.0784 6.35112ZM7.97555 14.0671C9.56983 12.9288 11.391 12.374 13.1315 12.4974C14.7464 12.7888 16.087 13.7968 16.8601 15.3003C15.3521 16.3574 13.6407 16.8814 11.9978 16.7877C10.3024 16.5425 8.86241 15.5683 7.97555 14.0671Z"
        stroke="currentColor"
        strokeWidth={2}
      />
    </svg>
  );
}
export default SvgCredit;
